import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type ManageScheduledTaskConfirmationModalProps = {
  onConfirm: () => void;
};

const ManageScheduledTaskConfirmationModal = create(function ManageScheduledTaskConfirmationModal({
  onConfirm,
}: ManageScheduledTaskConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Delete scheduling"
      confirmationButtonLabel="Delete"
      confirmationButtonVariant="dangerPrimary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to delete <strong>Task scheduling</strong>?
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showManageScheduledTaskConfirmationModal = (
  props: ManageScheduledTaskConfirmationModalProps
) => show(ManageScheduledTaskConfirmationModal, props);
